export const LISTS = Object.freeze({
    CIRCLES: "Circles",
    BOXES: "Boxes", // PhotoBox
    SQUARES: 'Squares', // SquareList
    COLLAGE: 'Collage', // SquareCollage
    LIST: "List", // PhotoList
    MESSAGES: "Messages", // MessageBoard
    DYNAMIC: "Dynamic", // DynamicList
    CONTENT_AND_DOCS: "ContentAndDocs", 
});